import uk from 'date-fns/locale/uk';

const DateTimeFormats = {
  sunday: 'Нд',
  monday: 'Пн',
  tuesday: 'Вт',
  wednesday: 'Ср',
  thursday: 'Чт',
  friday: 'Пт',
  saturday: 'Сб',
  ok: 'OK',
  today: 'Сьогодні',
  yesterday: 'Вчора',
  now: 'Зараз',
  hours: 'Години',
  minutes: 'Хвилини',
  seconds: 'Секунди',
  /**
   * Format of the string is based on Unicode Technical Standard #35:
   * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
   **/
  formattedMonthPattern: 'MMM yyyy',
  formattedDayPattern: 'dd MMM yyyy',
  shortDateFormat: 'dd/MM/yyyy',
  shortTimeFormat: 'HH:mm',
  dateLocale: uk as any,
};

const Combobox = {
  noResultsText: 'Нічого не знайдено',
  placeholder: 'Виберіть',
  searchPlaceholder: 'Пошук',
  checkAll: 'Усі',
};

const CreatableComboBox = {
  ...Combobox,
  newItem: 'Новий елемент',
  createOption: 'Створити опцію "{0}"',
};

export default {
  code: 'uk-UA',
  common: {
    loading: 'Завантаження...',
    emptyMessage: 'Дані не знайдено',
    remove: 'Видалити',
    clear: 'Очистити',
  },
  Plaintext: {
    unfilled: 'Не заповнено',
    notSelected: 'Не вибрано',
    notUploaded: 'Не завантажено',
  },
  Pagination: {
    more: 'Більше',
    prev: 'Назад',
    next: 'Вперед',
    first: 'Перший',
    last: 'Останній',
    limit: '{0} / сторінка',
    total: 'Всього рядків: {0}',
    skip: 'Перейти до {0}',
  },
  DateTimeFormats,
  Calendar: DateTimeFormats,
  DatePicker: DateTimeFormats,
  DateRangePicker: {
    ...DateTimeFormats,
    last7Days: 'Останні 7 днів',
  },
  Combobox,
  InputPicker: CreatableComboBox,
  TagPicker: CreatableComboBox,
  Uploader: {
    inited: 'Початковий',
    progress: 'Завантаження',
    error: 'Помилка',
    complete: 'Завершено',
    emptyFile: 'Порожній',
    upload: 'Завантажити',
    removeFile: 'Видалити файл',
  },
  CloseButton: {
    closeLabel: 'Закрити',
  },
  Breadcrumb: {
    expandText: 'Показати шлях',
  },
  Toggle: {
    on: 'Відк.',
    off: 'Закр.',
  },
};
